'use client';

import { memo as Memo } from 'react';

//* Components
import Page from '@components/global/Page';
import HTMLContainer from '@components/global/HTMLContainer';
import PageTopSection from '@components/global/PageTopSection';
import PortfolioList from '@components/cfModules/PortfolioList';

const Works = Memo(({ pageData, portfolios }) => {
	return (
		<Page>
			<HTMLContainer>
				<PageTopSection
					title={pageData.title}
					settings={pageData.settings}
					subtitle={pageData.subtitle}
					description={pageData.description}
				/>
			</HTMLContainer>

			<PortfolioList
				isFilter
				data={portfolios}
			/>
		</Page>
	);
});

export default Works;
